export default __webpack_public_path__ + "static/media/repituco-logo.f7e308ba.svg";